/**
 *  home.jsx
 *  @version: 1.0.0
 *  @author: DWIT MÉXICO - Kath
 *  @description: vista de ajustes legalidad
*/

import React from 'react';
import { Link } from 'react-router-dom';
import HeaderWebHomeLoggedIn from '../components/header/header-desktop';
import LeftBar from '../components/left-bar/left-bar';
import MediaQuery from 'react-responsive';
import LeftBarSetting from '../components/left-bar/left-settings-bar';
import ModalOfferAdd from '../components/modals/offerAdd';
import ModalVideoAdd from '../components/modals/AddVideo';

const SettingsLegality = () => (
    <div className="settings column">
        <MediaQuery minDeviceWidth = { 768 }>
            <HeaderWebHomeLoggedIn/>
            <div className="row">
                <LeftBar active = "menuSettings"/>
                <div className="column align-center">
                <div className="white-space-32"></div>
                    <div className="row-responsive container">
                        <LeftBarSetting link="/ajustes/perfil" option = "5"/>
                        <div className="column">
                            <form className="column">                               
                                <div className="row">
                                    <div className="column right-main content-forms align-center">
                                        <h4>
                                            Legalidad
                                        </h4>
                                        <div className="white-space-8"></div>
                                        <div className="input-container align-center justify-center">
                                            <i className="fas fa-file-alt  font-medium color-darkBlue"></i>
                                            <Link to="/files/politica-de-privacidad.pdf" target="_blank" className="input input-profile">Política de privacidad</Link>
                                        </div>  
                                        <div className="white-space-8"></div>
                                        <div className="input-container align-center justify-center">
                                            <i className="fas fa-file-alt font-medium color-darkBlue"></i>
                                            <Link to="/files/terminos-y-condiciones.pdf" target="_blank" className="input input-profile">Términos de uso</Link>
                                        </div>
                                        <div className="white-space-8"></div>
                                        <div className="input-container align-center justify-center">
                                            <i className="fas fa-file-alt font-medium color-darkBlue"></i>
                                            <Link to="/files/politica-de-cookies.pdf" target="_blank" className="input input-profile">Política de Cookies</Link>
                                        </div>
                                        <div className="white-space-16"></div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </MediaQuery>
        <ModalOfferAdd></ModalOfferAdd>
        <ModalVideoAdd></ModalVideoAdd>
    </div>
);

export default SettingsLegality;